export const BASE_URL = "https://tutorioplus.com/api";
//export const BASE_URL = "http://localhost:8080/api";

export const API_ENDPOINTS = {
  GETSTUDENTS: `${BASE_URL}/users/getstudents`,
  EDITSTUDENT: `${BASE_URL}/users/editstudent`,
  SIGNUP: `${BASE_URL}/users/signup`,
  DELETEUSER: `${BASE_URL}/users/deleteuser`,
  SIGNIN: `${BASE_URL}/users/signin`,
  GETASSIGNMENTS: `${BASE_URL}/services/getAssignmentList`,
  SUBMITANSWER: `${BASE_URL}/services/submitAnswer`,
  GETGRIEVANCE: `${BASE_URL}/grievances`,
  DELETEGRIEVANCE: `${BASE_URL}/grievances/deleteGrievance`,
  DELETEASSIGNMENT: `${BASE_URL}/services/deleteAssignment`,
  GETONLINECLASSREQUESTS: `${BASE_URL}/services/getSessionsList`,
  DELETEONLINECLASSREQUEST: `${BASE_URL}/services/deleteSession`,
  GETMENTORS: `${BASE_URL}/users/getmentors`,
  ADDMENTOR: `${BASE_URL}/users/addmentor`,
  EDITMENTOR: `${BASE_URL}/users/editmentor`,
  APPROVETUTOR: `${BASE_URL}/users/approvetutor`,
  GETUSERSTATS: `${BASE_URL}/users/stats`,
  GETASSIGNMENTSTATS: `${BASE_URL}/users/assignment-activity?range=`,
  GETNOTIFICATIONS: `${BASE_URL}/users/notifications?userId=`,
  MARKASRESOLVED: `${BASE_URL}/grievances/markAsResolved`,
  GETOTHERSERVICESLIST: `${BASE_URL}/services/getOtherServicesList`,
  UPDATESTATUS: `${BASE_URL}/services/updateStatus`,
  CHANGEPASSWORD: `${BASE_URL}/users/changepassword`,
  PAYMENTHISTORY: `${BASE_URL}/users/payment-history`,
  GETDEMOCLASSREQUEST: `${BASE_URL}/users/democlasslist`,
  UPDATEDEMOSTATUS: `${BASE_URL}/users/updateDemoClassStatus`,
  GETCOUNSELLINGLIST: `${BASE_URL}/services/getCounsellingList`,
};
